export enum LanguageMutationTypes {
    SET_LANG = 'SET_LANG',
  }
  